module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 2
// module chunks = 0